import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Organizations from "../components/Organizations";
import Problem from "../components/Problem";
import Features from "../components/Features";
import Audiences from "../components/Audiences";
import FinanceCourseSection from "../components/FinanceCourseSection";
import FundingSection from "../components/FundingSection";
import Pricing from "../components/Pricing";
import Testimonials from "../components/Testimonials";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import { Toaster } from "../components/ui/toaster";

const Landing = () => {
  return (
    <div className="bg-black text-white min-h-screen antialiased">
      <Navbar />
      <main>
        <Hero />
        <Organizations />
        <Problem />
        <Features />
        <FinanceCourseSection />
        <FundingSection />
        <Audiences />
        <Pricing />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default Landing;
